module.exports = __webpack_public_path__ + "static/media/chelianjiaochedan.92721346.png";